export default {
	namespaced: true,
	state: {
		sidebarMenu: null /** 导航菜单 */,
		currentMenu: 'order' /** 当前active导航菜单 */,
	},
	getters: {},
	mutations: {
		SET_MENU(state, menu) {
			state.sidebarMenu = menu
		},
		CLEAR_MENU(state) {
			state.sidebarMenu = null
		},
		SET_CURRENT_MENU(state, currentMenu) {
			state.currentMenu = currentMenu
		},
	},
	actions: {
		async SET_SIDEBAR_MENU({ commit, state }) {
			commit('CLEAR_MENU');
			// 左侧菜单显示
			let _child = [{
				path: '',
				redirect: 'order',
				name: 'searchOrigin',
				meta: {
					name: '订单管理',
					icon: 'el-icon-s-order',
				},
				children: [
					{
						path: 'order',
						name: 'order',
						meta: {
							name: '销售订单',
						},
					}, {
						path: 'assOrder',
						name: 'assOrder',
						meta: {
							name: '组装订单',
						},
					}, {
						path: 'purOrder',
						name: 'purOrder',
						meta: {
							name: '请购订单',
						},
					}, {
						path: 'outOrder',
						name: 'outOrder',
						meta: {
							name: '出库申请',
						}
					}
				]
			},{
				path: '',
				redirect: 'order',
				name: 'searchOrigin1',
				meta: {
					name: '顺丰下单',
					icon: 'el-icon-truck',
				},
				children: [
					{
						path: 'sfOrder',
						name: 'sfOrder',
						meta: {
							name: '顺丰下单',
						}
					},{
						path: 'sfMyAddress',
						name: 'sfMyAddress',
						meta: {
							name: '我的地址',
						}
					},{
						path: 'sfShippingAddress',
						name: 'sfShippingAddress',
						is_admin:true,
						meta: {
							name: '收货地址',
						}
					},{
						path: 'sfCompanyAddress',
						name: 'sfCompanyAddress',
						is_admin:true,
						meta: {
							name: '公司地址',
						}
					},{
						path: 'sfSetConfig',
						name: 'sfSetConfig',
						is_admin:true,
						meta: {
							name: '设置参数',
						}
					}
				]
			},{
				path: '',
				redirect: 'order',
				name: 'searchOrigin2',
				is_admin:true,
				meta: {
					name: '打印服务',
					icon: 'el-icon-printer',
				},
				children: [
					{
						path: 'sfPrinterNickname',
						name: 'sfPrinterNickname',
						is_admin:true,
						meta: {
							name: '打印机昵称管理',
						}
					},
					{
						path:'sfPrintServerList',
						name:'sfPrintServerList',
						is_admin:true,
						meta: {
							name: '打印服务器列表',
						}
					},
					
			]
		},
		{
			path: '',
			redirect: 'penaltyQuery',
			name: 'searchOrigin3',
			meta: {
				name: '罚息查询',
				icon: 'el-icon-message-solid',
			},
			children: [
				{
					path: 'penaltyQuery',
					name: 'penaltyQuery',
					meta: {
						name: '罚息查询',
					}
				},
				{
					path: 'salesmanAnalysis',
					name: 'salesmanAnalysis',
					meta: {
						name: '员工分析',
					}
				},
				{
					path: 'taskConfig',
					name: 'taskConfig',
					is_admin:true,
					meta: {
						name: '任务参数配置',
					}
				},
				{
				path: 'taskLog',
				name: 'taskLog',
				meta: {
					name: '任务执行日志',
				}
			},
			{
				path: 'syncTask',
				name: 'syncTask',
				meta: {
					name: '同步任务管理',
				}
			}
		]
	},
	{
		path: '',
		redirect: 'sn/list',
		name: 'searchOrigin4',
		meta: {
			name: '序列号管理',
			icon: 'el-icon-s-marketing',
		},
		children: [
			{
			path: 'sn/list',
			name: 'snList',
			meta: {
				name: '序列号库存查询',
			}
		},
		{
				path: 'sn/productList',
				name: 'productList',
				meta: {
					name: '物料清单查询',
				}
			},
			{
				path: 'sn/inventoryList',
				name: 'inventoryList',
				meta: {
					name: '库存查询',
				}
			},
			{
				path: 'sn/add',
				name: 'addSn',
				meta: {
					name: '添加 SN 号',
				}
			}
		]
	},
	{
		path: '',
		redirect: 'superReport',
		name: 'searchOrigin5',
		meta: {
			name: '超聚变上报',
			icon: 'el-icon-upload2',
		},
		children: [
			{
				path: 'superReport',
				name: 'superReport',
				meta: {
					name: '超聚变上报',
				}
			}
		]
	}
	];
			commit('SET_MENU', _child);
		}
	}
}
